import { render, staticRenderFns } from "./NosePunching2.vue?vue&type=template&id=2ff88590&scoped=true&"
import script from "./NosePunching2.vue?vue&type=script&lang=js&"
export * from "./NosePunching2.vue?vue&type=script&lang=js&"
import style0 from "./NosePunching2.vue?vue&type=style&index=0&id=2ff88590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff88590",
  null
  
)

export default component.exports